import PropTypes from 'prop-types'
import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react'
import { defaulChargeInstanceData } from '../constants/defaulChargeInstanceData'
import { defaulStateTable } from '@constants/defaultStates'
import { useReceivedPaymentDetailServices } from '../hooks/useReceivedPaymentDetailServices'

export const ReceivedPaymentDetailContext = createContext({
    getInitialData: async () => { },
    chargeInstanceDetailDataRef: null,
    loadingCollectionAdministrationTable: false,
    setLoadingCollectionAdministrationTable: () => { },
    loadingReceivedPaymentDetail: false,
    setLoadingReceivedPaymentDetail: () => { },
    chargeInstanceDetailData: defaulChargeInstanceData,
    setChargeInstanceDetailData: () => { },
    chargeInstanceTableData: defaulStateTable,
    setChargeInstanceTableData: () => { }
})

export const ReceivedPaymentDetailContextProvider = ({ children }) => {
    const { getChargeInstanceDetailService } = useReceivedPaymentDetailServices()

    const [loadingCollectionAdministrationTable, setLoadingCollectionAdministrationTable] = useState(false);
    const [loadingReceivedPaymentDetail, setLoadingReceivedPaymentDetail] = useState(false)
    const [chargeInstanceDetailData, setChargeInstanceDetailData] = useState(defaulChargeInstanceData)
    const [chargeInstanceTableData, setChargeInstanceTableData] = useState(structuredClone(defaulStateTable))
    const chargeInstanceDetailDataRef = useRef(defaulStateTable)

    const getInitialData = useCallback(async ({ charge_instance_id }) => {
        setLoadingCollectionAdministrationTable(true)
        const { data, metadata, charge_data, status_metrics } = await getChargeInstanceDetailService({
            setLoading: setLoadingCollectionAdministrationTable,
            charge_instance_id,
            previousData: chargeInstanceDetailDataRef.current.dataTable,
            currentPage: chargeInstanceDetailDataRef.current.currentPage,
            limit: 10
        })
        const defaultData = structuredClone(defaulStateTable)
        setChargeInstanceTableData({
            ...defaultData,
            columns: data.columns,
            dataTable: data.dataSource,
            currentParams: {
                ...defaulStateTable.currentParams,
                charge_instance_id
            },
            metadata,
        })
        setChargeInstanceDetailData({
            charge_data,
            status_metrics
        })
        chargeInstanceDetailDataRef.current = {
            charge_data,
            status_metrics
        }
        setLoadingCollectionAdministrationTable(false)
    }, [
        getChargeInstanceDetailService,
        setChargeInstanceTableData,
        setChargeInstanceDetailData,
    ])

    const values = useMemo(() => ({
        getInitialData,
        chargeInstanceDetailDataRef,
        loadingCollectionAdministrationTable,
        setLoadingCollectionAdministrationTable,
        loadingReceivedPaymentDetail,
        setLoadingReceivedPaymentDetail,
        chargeInstanceDetailData,
        setChargeInstanceDetailData,
        chargeInstanceTableData,
        setChargeInstanceTableData
    }), [getInitialData, loadingCollectionAdministrationTable, chargeInstanceDetailData, loadingReceivedPaymentDetail, chargeInstanceTableData])

    return (
        <ReceivedPaymentDetailContext.Provider value={values}>
            {children}
        </ReceivedPaymentDetailContext.Provider>
    )
}

ReceivedPaymentDetailContextProvider.propTypes = {
    children: PropTypes.node.isRequired
}

export const useReceivedPaymentDetailContext = () => {
    if (ReceivedPaymentDetailContext === undefined) {
        throw new Error('useReceivedPaymentDetailContext must be used within a ReceivedPaymentDetailContextProvider')
    }
    return useContext(ReceivedPaymentDetailContext)
}